import { ENVIRONMENTS } from '../exports/Constants';

/**
 * The public reservation site of a franchise. Shop sets `reservation_slug` only
 * when the franchise slug clashes with another franchise's on the reservation
 * domains, so it wins over `slug` whenever present.
 */
export function reservationSiteUrl(franchise, country) {
  const label = franchise?.reservation_slug ?? franchise?.slug;

  if (import.meta.env.VITE_APP_MODE === ENVIRONMENTS.PROD) {
    return country === 'DE' ? `https://${label}.tischreservieren.com` : `https://${label}.table-reserve.com`;
  }

  return `https://${label}.foodamigos-reservation-testseite.com`;
}
